/**
 * "<1m", "23m", "1h 33m" — the scale a reader thinks in for an AVERAGE over many
 * runs, which is why it stops at whole minutes where the pipeline tab's
 * formatter goes on to seconds: a mean of fifty builds carries no precision below
 * the minute. Rounded to the nearest minute throughout, and only a result of no
 * whole minute reads as "<1m" — "0m" is a measurement, and a build that takes
 * seconds is still a build (DX-354).
 *
 * `null` is "not known" and reads as a dash. The caller decides what counts as
 * unknown, because the CI snapshot carries 0 for it while a deployment carries
 * null.
 *
 * Shared by the home page's CI health and recent deployments cards, so the two
 * cannot disagree about the same number of seconds.
 */
export function formatDuration(sec: number | null): string {
  if (sec === null) return '—';
  const m = Math.round(sec / 60);
  if (m < 1) return '<1m';
  if (m < 60) return `${m}m`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}
